// extracted by mini-css-extract-plugin
export default {"mask":"AnimatedMask_mask__7yfz4","img":"AnimatedMask_img__EyH5f"};